/**
 * External dependencies
 */
import React from "react";
import { Puff } from "react-loading-icons";

/**
 * Internal dependencies
 */
//import preloaderIcon from 'assets/images/preloader.svg';
// <img src={preloaderIcon} alt='loading ...' />
/**
 * Style dependencies
 */
import "./styles.scss";

const Preloader = (props) => {
  return (
    <div className="preloader" style={{ background: props.background }}>
      <Puff stroke="#000" strokeOpacity={0.125} speed={0.75} />
    </div>
  );
};

Preloader.defaultProps = {
  background: "#fff",
};
Preloader.propTypes = {};

export default Preloader;
